import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPublicCollections } from "../../redux/collections/collectionsSlice";
import { AppDispatch, StoreState } from "../../redux/store";

const useFetchPublicCollections = (id: string | null) => {
  const dispatch = useDispatch<AppDispatch>();
  const { publicCollections, loading, error, shouldNavigateToPublicationPage } = useSelector((state: StoreState) => state.collections);
  const shouldFetch = useRef(true);
  useEffect(() => {
    if (id && shouldFetch.current) {
      dispatch(getPublicCollections({ creatorId: id, page: 1 }));
      shouldFetch.current = false;
    }
  }, [id, dispatch]);

  return { loading, error, publicCollections, shouldNavigateToPublicationPage };
};

export default useFetchPublicCollections;
